var _metadata, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorfulMotorCycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 249.99999 250.00001",
    id: "svg148",
    style: {
      opacity: 0.7
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata154"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs152"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.1487543,0,0,4.1487543,-605.22601,-791.81402)",
    id: "g146"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(146,179)",
    id: "g144"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.336,39.205)",
    id: "g4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    fillRule: "evenodd",
    d: "m 378.33,229.078 h 14.786 v 5.136 a 2.312,2.312 0 0 1 -2.305,2.307 h -5.318 l -3.172,1.6 -3.99,-1.6 z",
    transform: "translate(-378.33,-229.078)",
    id: "path2",
    style: {
      fill: "#ff9e71"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.744,46.648)",
    id: "g8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    fillRule: "evenodd",
    d: "m 245.808,292.6 h 7.162 v 3.295 a 1.44,1.44 0 0 1 -1.435,1.436 h -23.318 c 0,-2.071 0,-3.125 1.585,-3.125 h 3.156 c 1.986,0 3.289,-0.512 4.016,-1.6 z",
    transform: "translate(-228.217,-292.596)",
    id: "path6",
    style: {
      fill: "#6f6571"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.103,51.379)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    fillRule: "evenodd",
    d: "m 158.4,332.965 h 20.506 c 1.2,2.094 2.169,4.611 1.335,9.425 -1.4,-4.747 -15.566,-2.852 -17.021,2.626 h -15.636 c -0.591,-1.34 -1.149,-2.663 -1.638,-4 h 4.408 c 8.916,-3.363 6.046,-1.864 8.046,-8.051 z",
    transform: "translate(-145.946,-332.965)",
    id: "path10",
    style: {
      fill: "#ff9e71"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.762,26.363)",
    id: "g16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    fillRule: "evenodd",
    d: "m 237.434,131.647 a 33.458,33.458 0 0 0 1.186,4.545 l 4.508,1.766 5.026,-1.766 c -0.176,-9.511 -3.73,-14.073 -6.753,-15.549 a 7.337,7.337 0 0 0 -2.206,-1.142 c 0,0 -1.468,2.349 -1.545,2.349 a 12.616,12.616 0 0 0 -0.741,4.987 z",
    transform: "translate(-236.905,-119.501)",
    id: "path14",
    style: {
      fill: "#eceaec"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.581,43.054)",
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    fillRule: "evenodd",
    d: "m 224.184,261.929 h -9.534 c -2.2,0.239 -4.9,1.912 -4.9,7.091 v 5.429 h 4.976 v -4.2 c 0,-2.071 0,-3.125 1.585,-3.125 h 3.156 c 1.986,0 3.289,-0.512 4.016,-1.6 a 5.885,5.885 0 0 0 0.701,-3.595 z",
    transform: "translate(-209.754,-261.929)",
    id: "path18",
    style: {
      fill: "#ff8086"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.763,27.506)",
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    fillRule: "evenodd",
    d: "m 270.755,144.8 c -0.176,-9.511 -3.73,-14.073 -6.753,-15.549 a 6.1,6.1 0 0 1 -1.495,0.768 c 2.677,2.025 5.361,6.549 5.514,14.781 z",
    transform: "translate(-262.507,-129.247)",
    id: "path22",
    style: {
      fill: "#dad8db"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.483,43.054)",
    id: "g28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    fillRule: "evenodd",
    d: "m 291.25,261.929 h -2.734 a 5.884,5.884 0 0 1 -0.7,3.594 4.107,4.107 0 0 1 -2.1,1.6 h 0.814 c 1.986,0 3.289,-0.512 4.016,-1.6 a 5.885,5.885 0 0 0 0.704,-3.594 z",
    transform: "translate(-285.722,-261.929)",
    id: "path26",
    style: {
      fill: "#f76672"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.336,31.751)",
    id: "g32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    fillRule: "evenodd",
    d: "m 380.635,165.474 h 10.175 a 2.312,2.312 0 0 1 2.305,2.307 V 171.6 H 378.33 v -3.817 a 2.312,2.312 0 0 1 2.305,-2.309 z",
    transform: "translate(-378.33,-165.474)",
    id: "path30",
    style: {
      fill: "#ff9e71"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.336,36.724)",
    id: "g36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    fillRule: "evenodd",
    d: "m 378.33,207.914 h 14.786 v 3.627 H 378.33 Z",
    transform: "translate(-378.33,-207.914)",
    id: "path34",
    style: {
      fill: "#ff8086"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.73,31.751)",
    id: "g40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    fillRule: "evenodd",
    d: "m 460.8,170.447 h 3.086 v -2.666 a 2.312,2.312 0 0 0 -2.305,-2.307 h -3.086 a 2.312,2.312 0 0 1 2.305,2.307 z",
    transform: "translate(-458.494,-165.474)",
    id: "path38",
    style: {
      fill: "#ffc269"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.035,36.724)",
    id: "g44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    fillRule: "evenodd",
    d: "m 478.166,211.541 h 3.086 v -3.627 h -3.086 z",
    transform: "translate(-478.166,-207.914)",
    id: "path42",
    style: {
      fill: "#f76672"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.73,40.352)",
    id: "g48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    fillRule: "evenodd",
    d: "m 460.8,238.865 v 3.989 a 2.312,2.312 0 0 1 -2.305,2.307 h 3.086 a 2.3,2.3 0 0 0 2.305,-2.307 v -3.989 z",
    transform: "translate(-458.494,-238.865)",
    id: "path46",
    style: {
      fill: "#ffc269"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.377,54.597)",
    id: "g52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    fillRule: "evenodd",
    d: "m 293.347,369.26 a 8.693,8.693 0 0 1 17.021,-2.626 8.92,8.92 0 0 1 0.382,2.347 c 0.01,0.319 -0.209,0.279 -0.508,0.279 q -8.442,0 -16.895,0 z",
    transform: "translate(-293.347,-360.427)",
    id: "path50",
    style: {
      fill: "#a64ac9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.566,63.43)",
    id: "g56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    fillRule: "evenodd",
    d: "m 312.028,435.8 h 13.248 a 6.627,6.627 0 0 1 -13.248,0 z",
    transform: "translate(-312.028,-435.804)",
    id: "path54",
    style: {
      fill: "#6f6571"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.775,62.018)",
    id: "g60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    fillRule: "evenodd",
    d: "m 23.831,423.747 11.4,2.623 a 5.8489343,5.8489343 0 1 1 -11.4,-2.623 z",
    transform: "translate(-23.681,-423.747)",
    id: "path58",
    style: {
      fill: "#6f6571"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.879,55.372)",
    id: "g64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    fillRule: "evenodd",
    d: "m 8.7,370.492 a 7.955,7.955 0 0 1 7.331,-3.411 c 5.156,1.09 6.833,4.172 7.169,8.015 a 7.958,7.958 0 0 1 -0.176,1.573 c -0.033,0.146 -0.13,0.086 -0.289,0.05 l -1.784,-0.409 -11.4,-2.623 -0.854,-0.2 -1.197,-0.272 a 7.89,7.89 0 0 1 1.2,-2.723 z",
    transform: "translate(-7.503,-367.042)",
    id: "path62",
    style: {
      fill: "#eceaec"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.393,38.54)",
    id: "g68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    fillRule: "evenodd",
    d: "m 80.154,240.263 4.6,-15.931 2.073,-0.928 2.319,0.928 c -3.046,8.444 -2.2,14.339 -0.14,19.964 0.492,1.336 1.05,2.66 1.638,4 h -3.308 z",
    transform: "translate(-80.154,-223.404)",
    id: "path66",
    style: {
      fill: "#a64ac9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.298,20.454)",
    id: "g72"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    fillRule: "evenodd",
    d: "m 199.164,70.226 5.4,-1.15 c 0.548,0.05 2.116,1.366 2.116,2.191 l -1.149,5.845 a 5.276,5.276 0 0 1 -1.511,0.223 5.223,5.223 0 0 1 -4.857,-7.108 z",
    transform: "translate(-198.812,-69.076)",
    id: "path70",
    style: {
      fill: "#ffece4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.907,14.879)",
    id: "g76"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    fillRule: "evenodd",
    d: "m 186.935,28.227 a 6.579,6.579 0 1 1 13.155,0 7.038,7.038 0 0 1 -2.8,5.9 6.274,6.274 0 0 1 -2.239,0.984 v -5.844 c 0,-0.825 -0.419,-0.991 -0.967,-1.041 h -7.145 z",
    transform: "translate(-186.935,-21.501)",
    id: "path74",
    style: {
      fill: "#a64ac9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.042,14.879)",
    id: "g80"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    fillRule: "evenodd",
    d: "m 213.694,22.495 a 6.419,6.419 0 0 1 3.441,-0.994 6.65,6.65 0 0 1 6.577,6.726 7.038,7.038 0 0 1 -2.8,5.9 6.1,6.1 0 0 1 -1.525,0.778 7.65,7.65 0 0 0 2.06,-5.436 6.956,6.956 0 0 0 -6.876,-7.031 6.349,6.349 0 0 0 -0.874,0.057 z",
    transform: "translate(-213.694,-21.501)",
    id: "path78",
    style: {
      fill: "#f76672"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.504,55.574)",
    id: "g84"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    fillRule: "evenodd",
    d: "m 186.574,368.767 h 4.976 v 3.133 c 0,0.672 -0.365,0.721 -0.9,0.721 h -7.15 c -0.143,-3.145 1.761,-3.856 3.069,-3.856 z",
    transform: "translate(-183.497,-368.767)",
    id: "path82",
    style: {
      fill: "#6f6571"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.053,39.467)",
    id: "g88"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    fillRule: "evenodd",
    d: "m 124.117,251.283 c -2.056,-5.625 -2.907,-11.519 0.14,-19.964 h -2.342 c -3.046,8.444 -2.2,14.339 -0.14,19.964 0.488,1.336 1.046,2.66 1.638,4 h 2.342 c -0.588,-1.341 -1.146,-2.664 -1.638,-4 z",
    transform: "translate(-119.921,-231.319)",
    id: "path86",
    style: {
      fill: "#f76672"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.22,55.373)",
    id: "g92"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    fillRule: "evenodd",
    d: "M 70.965,375.1 63.8,367.083 a 7.834,7.834 0 0 0 -2.183,0.087 l 6.89,7.7 a 7.931,7.931 0 0 1 -0.136,1.36 l 0.349,0.08 1.784,0.409 c 0.159,0.037 0.256,0.1 0.289,-0.05 a 7.931,7.931 0 0 0 0.172,-1.569 z",
    transform: "translate(-61.614,-367.044)",
    id: "path90",
    style: {
      fill: "#dad8db"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.557,51.379)",
    id: "g96"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    fillRule: "evenodd",
    d: "m 272.723,332.965 h -20.506 v 1.805 h 16.849 a 2.5,2.5 0 0 1 2.558,1.792 8.322,8.322 0 0 1 0.681,2.636 8.811,8.811 0 0 1 1.754,3.191 c 0.833,-4.813 -0.134,-7.33 -1.336,-9.424 z",
    transform: "translate(-252.217,-332.965)",
    id: "path94",
    style: {
      fill: "#ffc269"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.17,54.597)",
    id: "g100"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    fillRule: "evenodd",
    d: "m 359.79,363.442 a 8.632,8.632 0 0 0 -6.564,-3.015 8.8,8.8 0 0 0 -1.91,0.209 8.775,8.775 0 0 1 6.787,8.345 c 0.007,0.219 -0.093,0.269 -0.252,0.279 h 3.568 c 0.3,0 0.518,0.04 0.508,-0.279 a 8.912,8.912 0 0 0 -0.382,-2.347 c -0.007,-0.023 -0.013,-0.043 -0.02,-0.063 v 0 a 8.819,8.819 0 0 0 -1.735,-3.129 z",
    transform: "translate(-351.316,-360.427)",
    id: "path98",
    style: {
      fill: "#f76672"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.775,62.018)",
    id: "g104"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    fillRule: "evenodd",
    d: "m 34.876,426.29 -11.048,-2.543 a 5.811,5.811 0 0 0 -0.146,1.559 l 8.77,2.018 0.345,0.08 a 5.813,5.813 0 0 1 -2.252,3.418 5.843,5.843 0 0 0 4.68,-4.451 z",
    transform: "translate(-23.676,-423.747)",
    id: "path102",
    style: {
      fill: "#5d5360"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.566,63.43)",
    id: "g108"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    fillRule: "evenodd",
    d: "m 323.165,435.8 h -11.138 a 6.876,6.876 0 0 0 0.409,2 h 9.864 a 6.848,6.848 0 0 1 -1.624,4.089 6.764,6.764 0 0 0 4.594,-6.087 z",
    transform: "translate(-312.027,-435.804)",
    id: "path106",
    style: {
      fill: "#5d5360"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.562,46.648)",
    id: "g112"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    fillRule: "evenodd",
    d: "M 394.726,295.891 V 292.6 h -4.5 v 3.295 a 1.44,1.44 0 0 1 -1.435,1.436 h 4.5 a 1.44,1.44 0 0 0 1.435,-1.44 z",
    transform: "translate(-388.79,-292.596)",
    id: "path110",
    style: {
      fill: "#5d5360"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.325,21.604)",
    id: "g116"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    fillRule: "evenodd",
    d: "m 199.039,80.224 h 4.438 c 0.548,0.05 0.967,0.219 0.967,1.044 v 4.724 a 5.33,5.33 0 0 0 1.289,-0.216 v -5.844 c 0,-0.825 -0.419,-0.991 -0.967,-1.041 h -5.4 a 5.22,5.22 0 0 0 -0.327,1.333 z",
    transform: "translate(-199.039,-78.891)",
    id: "path114",
    style: {
      fill: "#ffddce"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.782,34.232)",
    id: "g120"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    fillRule: "evenodd",
    d: "m 101.791,186.861 6.215,2.055 a 5.522,5.522 0 0 1 -0.246,2.962 h -7.225 V 187.3 c 0,-0.9 0.465,-0.7 1.256,-0.439 z",
    transform: "translate(-100.535,-186.642)",
    id: "path118",
    style: {
      fill: "#ff9e71"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.752,36.272)",
    id: "g124"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    fillRule: "evenodd",
    d: "m 155.88,207.251 h -3.142 c -1.687,0 -1.737,-2.8 0.246,-2.962 l 2.9,-0.233 0.777,1.646 z",
    transform: "translate(-151.484,-204.056)",
    id: "path122",
    style: {
      fill: "#ffece4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.149,32.119)",
    id: "g128"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    fillRule: "evenodd",
    d: "m 194.62,170.192 1.04,-0.894 c 2.6,-2.244 5.9,1.543 2.415,3.8 l -2.93,1.9 -1.475,0.957 H 189 v -3.195 l 2.9,-0.236 z",
    transform: "translate(-189.003,-168.611)",
    id: "path126",
    style: {
      fill: "#ff8086"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.751,37.891)",
    id: "g132"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    fillRule: "evenodd",
    d: "M 155.873,219.448 V 217.9 h -4.1 a 1.294,1.294 0 0 1 -0.282,-0.027 1.3,1.3 0 0 0 1.242,1.576 h 3.142 z",
    transform: "translate(-151.475,-217.872)",
    id: "path130",
    style: {
      fill: "#ffddce"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.149,32.502)",
    id: "g136"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    fillRule: "evenodd",
    d: "m 198.076,175.991 c 2.106,-1.37 1.734,-3.295 0.535,-4.106 a 2.724,2.724 0 0 1 -1.495,2.56 l -2.282,1.479 -0.644,0.422 -1.475,0.954 H 189 v 1.549 h 4.667 l 1.475,-0.957 z",
    transform: "translate(-189.004,-171.885)",
    id: "path134",
    style: {
      fill: "#f76672"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.803,35.681)",
    id: "g140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    fillRule: "evenodd",
    d: "m 138.3,199.831 -2.5,-0.825 a 3.8,3.8 0 0 0 -0.7,3.787 h 2.96 a 1.3,1.3 0 0 1 -1.242,-1.576 1.559,1.559 0 0 1 1.482,-1.386 z",
    transform: "translate(-134.852,-199.006)",
    id: "path138",
    style: {
      fill: "#ffc269"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 56.816,30.872 H 46.641 a 3.189,3.189 0 0 0 -3.184,3.186 v 11.711 h -3.806 a 8.742,8.742 0 0 0 0.238,-2.731 v 0 a 25.544,25.544 0 0 0 -2.406,-11.172 11.988,11.988 0 0 0 -3.724,-4.49 8.15,8.15 0 0 0 2.181,-5.776 7.458,7.458 0 1 0 -14.912,0 0.879,0.879 0 0 0 0.879,0.879 h 0.6 a 6.188,6.188 0 0 0 -0.084,1.013 6.1,6.1 0 0 0 4.9,5.978 14.813,14.813 0 0 0 -0.437,3.823 l -2.192,1.885 -5.334,0.431 -6.153,-2.034 a 1.863,1.863 0 0 0 -1.758,0 1.561,1.561 0 0 0 -0.546,1.311 v 4.574 a 0.879,0.879 0 0 0 0.879,0.879 h 1.046 l -1.6,5.546 a 0.87918172,0.87918172 0 0 0 1.689,0.489 l 1.746,-6.034 h 2.5 c -3.108,9.477 -1.335,15.8 1.391,22.205 h -1.58 l -6.58,-7.358 1.391,-4.807 A 0.88082703,0.88082703 0 0 0 10.09,49.9 l -1.331,4.6 a 8.841,8.841 0 0 0 -8.737,6.848 0.879,0.879 0 0 0 0.66,1.052 l 1.248,0.287 a 6.725,6.725 0 0 0 13,2.991 l 0.984,0.227 a 1.148,1.148 0 0 0 0.849,-0.047 1.009,1.009 0 0 0 0.5,-0.674 8.744,8.744 0 0 0 0.142,-0.875 h 18.373 a 7.49,7.49 0 0 0 14.823,0 h 0.834 a 1.2,1.2 0 0 0 0.913,-0.331 1.127,1.127 0 0 0 0.311,-0.855 9.963,9.963 0 0 0 -0.36,-2.381 c 0.7,-4.25 0.026,-6.839 -0.972,-8.865 a 2.314,2.314 0 0 0 1.05,-1.937 v -2.413 h 4.439 A 3.189,3.189 0 0 0 60,44.341 V 34.058 A 3.188,3.188 0 0 0 56.816,30.872 Z M 11.26,67.544 a 4.93,4.93 0 0 1 -3.749,0.632 v 0 a 4.98,4.98 0 0 1 -3.85,-5.087 l 9.534,2.194 a 4.941,4.941 0 0 1 -1.935,2.261 z m 4.4,-3.5 L 1.986,60.9 a 7.078,7.078 0 0 1 7,-4.637 l 6.7,7.488 Q 15.672,63.9 15.657,64.044 Z M 28.933,48.728 a 7.825,7.825 0 0 0 -0.255,2.651 V 54.7 H 25.46 v -4.55 c 0,-5.144 2.808,-6.061 4.068,-6.212 h 8.617 a 3.726,3.726 0 0 1 -0.8,2.524 4.081,4.081 0 0 1 -3.049,0.914 h -3.155 a 2.118,2.118 0 0 0 -2.208,1.353 z m -0.255,7.725 v 2.1 H 22.41 a 2.5,2.5 0 0 1 0.606,-1.5 2.168,2.168 0 0 1 1.564,-0.6 z M 38.105,42.175 H 30.112 A 32.818,32.818 0 0 1 29.27,38.922 l 2.43,-1.577 a 3.628,3.628 0 0 0 1.893,-3.34 3.107,3.107 0 0 0 -1.936,-2.544 3.173,3.173 0 0 0 -2.95,0.325 10.377,10.377 0 0 1 0.424,-2.228 6.2,6.2 0 0 0 1.112,-0.219 7.281,7.281 0 0 0 2.052,-0.813 c 1.693,1.011 5.416,4.292 5.81,13.649 z M 22.85,20.726 A 5.69,5.69 0 0 1 34.182,21.605 5.968,5.968 0 0 1 30.9,27.27 v -4.625 a 1.749,1.749 0 0 0 -1.766,-1.916 q -0.04,0 -0.08,0 z m 1.327,2.774 a 4.377,4.377 0 0 1 0.117,-1.013 h 4.714 c 0.054,0.006 0.094,0.012 0.122,0.018 a 1.045,1.045 0 0 1 0.009,0.144 v 5.142 a 4.348,4.348 0 0 1 -0.631,0.047 H 28.5 A 4.338,4.338 0 0 1 24.177,23.5 Z m -1.139,13.581 2.082,-0.168 a 0.879,0.879 0 0 0 0.5,-0.21 l 3.757,-3.231 v 0 A 1.746,1.746 0 0 1 30.509,33 a 1.353,1.353 0 0 1 1.335,1.179 1.939,1.939 0 0 1 -1.1,1.694 l -4.187,2.717 h -3.519 z m -3.714,0.3 1.957,-0.158 v 1.365 h -2.274 c -0.295,0 -0.367,-0.245 -0.375,-0.45 a 0.7,0.7 0 0 1 0.692,-0.757 z m -2.08,-0.607 a 2.539,2.539 0 0 0 -0.324,1.807 c 0,0 0,0 0,0.007 h -4.26 v -3.337 l 4.586,1.516 z m 1.768,3.572 h 7.8 a 0.879,0.879 0 0 0 0.478,-0.142 l 0.4,-0.258 c 0.191,0.846 0.409,1.669 0.647,2.446 -1.793,0.529 -4.638,2.239 -4.638,7.753 v 4.638 a 3.668,3.668 0 0 0 -1.956,1.051 4.287,4.287 0 0 0 -1.1,2.717 h -1.77 C 17.087,53.4 16.407,47.924 19.011,40.346 Z m 1.449,22.2 c -0.325,-0.747 -0.638,-1.491 -0.933,-2.238 h 9.126 c 1.183,0 1.782,-0.538 1.782,-1.6 v -6.45 h 6.937 a 0.879,0.879 0 1 0 0,-1.758 h -6.931 a 3.979,3.979 0 0 1 0.135,-1.149 c 0.044,-0.117 0.083,-0.219 0.566,-0.219 h 3.156 a 5.671,5.671 0 0 0 4.322,-1.462 c 0.043,-0.045 0.084,-0.093 0.125,-0.141 h 11.873 v 2.416 a 0.564,0.564 0 0 1 -0.556,0.557 h -8.75 a 0.879,0.879 0 1 0 0,1.758 h 8.233 a 10.377,10.377 0 0 1 1.282,5.429 9.538,9.538 0 0 0 -14.528,-1.137 9.682,9.682 0 0 0 -2.763,6 z m 22.73,6.413 a 5.791,5.791 0 0 1 -5.625,-4.652 h 11.249 a 5.792,5.792 0 0 1 -5.626,4.652 z m 6.624,-6.41 H 35.3 a 7.884,7.884 0 0 1 7.777,-7.075 7.8,7.8 0 0 1 7.479,5.588 l 0.01,0.031 a 8.112,8.112 0 0 1 0.29,1.456 z m 8.429,-18.21 a 1.429,1.429 0 0 1 -1.427,1.428 h -11.6 V 41.23 h 13.026 z m 0,-4.868 H 45.215 V 37.6 h 13.028 z m 0,-3.627 H 45.215 v -1.786 a 1.429,1.429 0 0 1 1.427,-1.428 h 10.174 a 1.429,1.429 0 0 1 1.427,1.428 z",
    style: {
      fill: "#393b45"
    },
    id: "path142"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorfulMotorCycle);
export default __webpack_public_path__ + "static/media/ColorfulMotorCycle.7cb09167f1f8a2e5c2c7a29490f2a420.svg";
export { ForwardRef as ReactComponent };